import axios from '@/http/index';

const base = '';
// 查询提现明细
export const selectDrawCashPage = (param) => axios.get(`${base}/erp/cashBox/selectDrawCashPage`, param).then((res) => res.data);
// 查询可提现金额
export const selectCashBoxSum = (param) => axios.get(`${base}/erp/cashBox/selectCashBoxSum`, param).then((res) => res.data);
// 获取提现二维码
export const obtainGainQRCode = (param) => axios.get(`${base}/erp/cashBox/obtainGainQRCode`, param).then((res) => res.data);
// 审核状态
export const businessLimit = (param) => axios.get(`${base}/erp/cashBox/businessLimit`, param).then((res) => res.data);
// 查询钱箱收入明细
export const selectIncomeCashPage = (param) => axios.get(`${base}/erp/cashBox/selectIncomeCashPage`, param).then((res) => res.data);
// （5.2）保存钱箱提现信息
export const saveDrawCash = (param) => axios.post(`${base}/erp/cashBox/saveDrawCash`, param).then((res) => res.data);
